export default "__VITE_ASSET__2684553d__"